import { stringify } from 'qs';
import request from '@/utils/request';

// ---- Global Route Definitions ----
export async function queryRouteDefinitionList(params) {
  return request(`/api-routes?${stringify(params)}`);
}

export async function queryRouteDefinitionDetail(id) {
  return request(`/api-routes/${id}`);
}

export async function createRouteDefinition(data) {
  return request('/api-routes', {
    method: 'POST',
    data,
  });
}

export async function updateRouteDefinition(params) {
  const { id, ...data } = params;
  return request(`/api-routes/${id}`, {
    method: 'PUT',
    data,
  });
}

export async function deleteRouteDefinition(id) {
  return request(`/api-routes/${id}`, {
    method: 'DELETE',
  });
}

export async function toggleRouteDefinitionStatus(id, status) {
  return request(`/api-routes/${id}/status`, {
    method: 'PATCH',
    data: { status },
  });
}

// ---- Credentials ----
export async function queryCredentialList(params) {
  return request(`/api-credentials?${stringify(params)}`);
}

export async function queryCredentialDetail(id) {
  return request(`/api-credentials/${id}`);
}

export async function createCredential(data) {
  return request('/api-credentials', {
    method: 'POST',
    data,
  });
}

export async function updateCredential(params) {
  const { id, ...data } = params;
  return request(`/api-credentials/${id}`, {
    method: 'PUT',
    data,
  });
}

export async function deleteCredential(id) {
  return request(`/api-credentials/${id}`, {
    method: 'DELETE',
  });
}

export async function resetCredentialSecret(id) {
  return request(`/api-credentials/${id}/reset-secret`, {
    method: 'POST',
  });
}

export async function toggleCredentialStatus(id, status) {
  return request(`/api-credentials/${id}/status`, {
    method: 'PATCH',
    data: { status },
  });
}

// ---- Credential-Route Bindings ----
export async function queryCredentialBindings(id, params) {
  return request(`/api-credentials/${id}/routes?${stringify(params)}`);
}

export async function bindCredentialRoutes(id, routeIds) {
  return request(`/api-credentials/${id}/routes`, {
    method: 'POST',
    data: { route_ids: routeIds },
  });
}

export async function unbindCredentialRoute(credentialId, routeId) {
  return request(`/api-credentials/${credentialId}/routes/${routeId}`, {
    method: 'DELETE',
  });
}

export async function toggleBindingStatus(credentialId, routeId, status) {
  return request(`/api-credentials/${credentialId}/routes/${routeId}/status`, {
    method: 'PATCH',
    data: { status },
  });
}
